import { Badge } from "@/components/ui/badge";
import { ScoresDetails } from "@/lib/api/mentor-scoring";
import { ColumnDef } from "@tanstack/react-table";
import { format } from "date-fns";
import {
  Avatar,
  AvatarFallback,
  AvatarImage,
} from "@/components/ui/avatar.tsx";
import { getInitials } from "@/lib/utils";
import { useSignedMedia } from "@/lib/hooks/use-signed-media";
import { Button } from "../ui/button";
import { useRouter } from "@tanstack/react-router";



export const columns: ColumnDef<ScoresDetails>[] = [
  {
    accessorKey: "mentor",
    header: "Mentor",
    cell: ({ row }) => {
      const name = row.original.mentor.first_name + " " + row.original.mentor.last_name;
      const avatarUrl = useSignedMedia(row.original.mentor.profile_picture_url);
      
      return (
        <div className="flex items-center gap-2">
          <Avatar className="h-8 w-8">
            <AvatarImage src={avatarUrl?.url ?? ""} alt={row.original.mentor.first_name ?? ""} />
            <AvatarFallback className="text-xs">
              {getInitials(name)}
            </AvatarFallback>
          </Avatar>
          <div className="flex items-center gap-1">
            <div className="font-bold">{name}</div>
          </div>
        </div>
      );
    },
    
  },
  {
    accessorKey: "final_score",
    header: "Final Score",
    cell: ({ row }) => {
      const score = row.original.final_score;
      return (
        <div className="max-w-[300px] truncate flex justify-center">
          <Badge variant="outline">{score}</Badge>
        </div>
      );
    },
  },
  {
    accessorKey: "average_score",
    header: "Average Satisfaction Score",
    cell: ({ row }) => {
      const score = row.original.average_satisfaction_score;
      return (
        <div className="max-w-[300px] truncate flex justify-center">
          <Badge variant="outline">{score ?? "N/A"}</Badge>
        </div>
      );
    },
  },
  {
    accessorKey: "active_teens",
    header: "Total Active Teens",
    cell: ({ row }) => {
      const score = row.original.total_active_teens;
      return (
        <div className="max-w-[300px] truncate flex justify-center">
          <Badge variant="outline">{score}</Badge>
        </div>
      );
    },
  },
  {
    accessorKey: "last_window_teens",
    header: "Teens Last Window",
    cell: ({ row }) => {
      const score = row.original.total_mentees_last_window;
      return (
        <div className="max-w-[300px] truncate flex justify-center">
          <Badge variant="outline">{score}</Badge>
        </div>
      );
    },
  },
  {
    accessorKey: "first_week_engagement_count",
    header: "First week engaged teens",
    cell: ({ row }) => {
      const score = row.original.first_week_engagement_count;
      return (
        <div className="max-w-[300px] truncate flex justify-center">
          <Badge variant="outline">{score}</Badge>
        </div>
      );
    },
  },
  {
    accessorKey: "month1_retention_count",
    header: "Month 1 teens retained",
    cell: ({ row }) => {
      const score = row.original.month1_retention_count;
      return (
        <div className="max-w-[300px] truncate flex justify-center">
          <Badge variant="outline">{score}</Badge>
        </div>
      );
    },
  },
  {
    accessorKey: "month3_retention_count",
    header: "Month 3 teens retained",
    cell: ({ row }) => {
      const score = row.original.month3_retention_count;
      return (
        <div className="max-w-[300px] truncate flex justify-center">
          <Badge variant="outline">{score}</Badge>
        </div>
      );
    },
  },
  {
    accessorKey: "snapshot_date",
    header: "Date",
    cell: ({ row }) => {
      return (
        <div className="text-sm text-gray-500">
          {format(new Date(row.original.snapshot_date), "MMM d, yyyy")}
        </div>
      );
    },
  },
  {
    accessorKey: "view_snapshots",
    header: "View Snapshots",
    cell: ({ row }) => {
      const router = useRouter();
      return (
        <div className="text-sm text-black-500">
          <Button onClick={(event) => {
                    event.stopPropagation();
                    router.navigate({
                      to: `/mentor-scoring/${row.original.mentor_id}`,
                    });
                  }} variant="outline" className="mx-auto flex">
            View Snapshots
          </Button>
        </div>
      );
    },
  },
];
